import axios from 'axios';
import config from '../../config';
import { STORAGE_KEYS } from '../../utils/constants';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGIN_RESET = 'LOGIN_RESET';
export const LOGOUT = 'LOGOUT';
export const SET_USER = 'SET_USER';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const LOGIN_MFA_REQUIRED = 'LOGIN_MFA_REQUIRED';
export const LOGIN_PASSWORD_REQUIRED = 'LOGIN_PASSWORD_REQUIRED';
export const LOGIN_OTP_REQUIRED = 'LOGIN_OTP_REQUIRED';
export const LOGIN_RESET_PASSWORD_REQUIRED = 'LOGIN_RESET_PASSWORD_REQUIRED';

export const login = (params) => {
  return {
    type: LOGIN,
    params,
  };
};

export const loginSuccess = (response) => {
  return {
    type: LOGIN_SUCCESS,
    response,
  };
};

export const loginFail = (response) => {
  return {
    type: LOGIN_FAIL,
    response,
  };
};

export const loginReset = () => {
  return {
    type: LOGIN_RESET,
  };
};

export const logout = () => {
  return {
    type: LOGOUT,
  };
};

export const setUser = (user) => {
  return {
    type: SET_USER,
    user,
  };
};

export const initializeAuth = () => {
  return {
    type: INITIALIZE_AUTH,
  };
};

export const loginMfaRequired = (response) => {
  return {
    type: LOGIN_MFA_REQUIRED,
    response,
  };
};

export const loginPasswordRequired = (response) => {
  return {
    type: LOGIN_PASSWORD_REQUIRED,
    response,
  };
};

export const loginOtpRequired = (response) => {
  return {
    type: LOGIN_OTP_REQUIRED,
    response,
  };
};

export const loginResetPasswordRequired = (response) => {
  return {
    type: LOGIN_RESET_PASSWORD_REQUIRED,
    response,
  };
};

export const loginApi = (data) => {
	return (dispatch) => {
		dispatch(login());
		axios
			.post(`${config.api.base_url}/auth/login`, data)
			.then((response) => {
				const loginData = response.data;
				const mode = loginData?.data?.mode;

				// Step 1 responses: mode tells us what the frontend should do
				if (mode === 'sign-in-link') {
					dispatch(loginMfaRequired(loginData));
					return;
				}
				if (mode === 'otp') {
					dispatch(loginOtpRequired(loginData));
					return;
				}
				if (mode === 'reset-password') {
					dispatch(loginResetPasswordRequired(loginData));
					return;
				}
				if (mode === 'password') {
					dispatch(loginPasswordRequired(loginData));
					return;
				}

				// Step 2 (or direct login): full login payload
				dispatch(loginSuccess(loginData));
			})
			.catch((error) => {
				dispatch(loginFail(error.response?.data || { message: 'Login failed' }));
			});
	};
};

export const resendMagicLinkApi = ({ mfaSessionToken }) => {
	return (dispatch) => {
		return axios
			.post(`${config.api.base_url}/auth/magic-link/resend`, { mfaSessionToken })
			.then((response) => response.data)
			.catch((error) => {
				return error.response?.data || { status: 0, message: 'Resend failed' };
			});
	};
};

// Provider (Cognito / Azure) email-OTP MFA
export const verifyOtpApi = ({ email, mfaSessionToken, otp }) => {
	return (dispatch) => {
		dispatch(login());
		axios
			.post(`${config.api.base_url}/auth/verify-otp`, { email, mfaSessionToken, otp })
			.then((response) => {
				const data = response.data;
				// After OTP verify, backend may still route the user through the
				// reset-password flow if their password_reset_required flag is set.
				if (data?.data?.mode === 'reset-password') {
					dispatch(loginResetPasswordRequired(data));
					return;
				}
				dispatch(loginSuccess(data));
			})
			.catch((error) => {
				dispatch(loginFail(error.response?.data || { message: 'OTP verification failed' }));
			});
	};
};

export const resendOtpApi = ({ email, mfaSessionToken }) => {
	return (dispatch) => {
		return axios
			.post(`${config.api.base_url}/auth/resend-otp`, { email, mfaSessionToken })
			.then((response) => response.data)
			.catch((error) => {
				return error.response?.data || { status: 0, message: 'Resend failed' };
			});
	};
};

export const consumeMagicLinkApi = ({ token, mfaSessionToken }) => {
	return (dispatch) => {
		dispatch(login());
		axios
			.post(`${config.api.base_url}/auth/magic-link/consume`, { token, mfaSessionToken })
			.then((response) => {
				dispatch(loginSuccess(response.data));
			})
			.catch((error) => {
				dispatch(loginFail(error.response?.data || { message: 'Sign-in link is invalid or expired' }));
			});
	};
};

export const logoutApi = () => {
	return (dispatch) => {
		const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
		if (token) {
			axios
				.post(`${config.api.base_url}/auth/logout`, {}, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.catch(() => {
					// Ignore errors on logout
				});
		}
		// Clear localStorage
		localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
		localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
		localStorage.removeItem(STORAGE_KEYS.USER_DATA);
		localStorage.removeItem(STORAGE_KEYS.PERMISSIONS);
		// Also clear transient sign-in flags (safe to clear — they belong to the just-ended session)
		localStorage.removeItem('mfaLastConsumedToken');
		localStorage.removeItem('mfaSessionToken');
		localStorage.removeItem('mfaMaskedEmail');
		localStorage.removeItem('mfaExpiryMinutes');
		dispatch(logout());
	};
};

